import {put, select} from "../../../shared/SagaService";
import {RowType} from "../../../components/Editable/FormItem/Rows/RowType";
import {TableName, hasErrorFn} from "../../EditableTable/options";
import {calculateItemRow} from "./calculateItemRow";
import {calculateSubtotal} from "./calculateSubtotal";
import {calculateSummary} from "./calculateSummary";
import EditableActions from "../../EditableTable/actions";
import TransactionActions from "../actions";
import {getAppliedLinkItems} from "./getAppliedLinkItems";
import {calculateDisplayNumbers} from "./calculateDisplayNumbers";
import {calculateBundleRow} from "./calculateBundleRow";
import { Type } from "../helper";
import InstructionActions from 'bukku/redux/Instruction/actions';

const selectorFn = state => ({
    formItems: state.Editable[TableName.form_item].items,
    bankItems: state.Editable[TableName.bank_item].items,
    activeTable: state.Editable.activeTable,
    taxCodes: state.List.taxCodes,
    taxMode: state.Transaction.taxMode,
    isRoundingOn: state.Transaction.isRoundingOn,
    editable: state.Editable,
});

export function* calculateAll(props) {
    const {
        activeTable,
        formItems,
        bankItems,
        taxCodes,
        taxMode,
        isRoundingOn,
        editable,
    } = selectorFn(yield select());

    const { initRequestAction } = props || {};
    const { type } = initRequestAction || {};
    const { transactionType } = initRequestAction || {};

    console.log('aaa calculateAll redux 1', {initRequestAction, transactionType});
    let parsedItems;
    let tableUsed;

    if (type === InstructionActions.INIT_INSTRUCTION_REQUEST) {
        tableUsed = activeTable || TableName.form_item;
        parsedItems = editable[tableUsed].items;
    }

    else {
        switch (transactionType) {
            case Type.bank_income:
            case Type.bank_expense:
            case Type.bank_transfer:
                tableUsed = TableName.bank_item;
                parsedItems = bankItems;
                break;
            case Type.sale_quote:
            case Type.sale_order:
            case Type.sale_delivery_order:
            case Type.sale_invoice:
            case Type.sale_invoice_cash:
            case Type.sale_delivery_note:
            case Type.delivery_note:
            case Type.sale_credit_note:
            case Type.sale_payment:
            case Type.sale_refund:
            case Type.purchase_order:
            case Type.purchase_goods_received_note:
            case Type.purchase_bill:
            case Type.purchase_bill_cash:
            case Type.purchase_bill_claim:
            case Type.purchase_credit_note:
            case Type.purchase_payment:
            case Type.purchase_refund:
            default:
                tableUsed = TableName.form_item;
                parsedItems = formItems;
                break;
        }
    }

    const isSubtotalSubtitle = type => type === RowType.subtotal || type === RowType.subtitle;

    // Step 0 (preprocess): If quantity is not given, assume it is 1 (except subtitle, subtotal row)
    const items1 = parsedItems.map(record => {
        if (!isSubtotalSubtitle(record.type) && (record.quantity === "" || record.quantity === null || record.quantity === undefined))
            return {...record, quantity: 1, changedQuantity: true};
        return record;
    });

    console.log('aaa1-1 calculateSummary redux 1', {
        activeTable,
        tableUsed,
        props,
        bankItems,
        items1,
    });

    // Step 1: Calculate amount, discount_amount, tax_amount
    const items2 = items1.map(record => {
        switch (record.type) {
            case RowType.subtotal:
            case RowType.subtitle:
                return record;
            case RowType.bundle:
                return calculateBundleRow(record, taxMode, taxCodes);
            case RowType.item:
            default:
                return calculateItemRow(record, taxMode, taxCodes, (activeTable || tableUsed));
        }
    });
    console.log('aaa1-1 calculateSummary redux 2', {
        items2,
    });

    // Step 2: Calculate all subtotals
    const items3 = calculateSubtotal(items2);

    console.log('aaa1-1 calculateSummary redux 3', {
        items3,
    });

    // Step 3: Calculate for summary
    const appliedLinkItems = yield getAppliedLinkItems();

    console.log('aaa1-1 calculateSummary redux 4', {
        items3,
        isRoundingOn,
    });
    const {
        summary,
        appliedLinkItems: appliedLinkItems2,
    } = calculateSummary(items3, appliedLinkItems, taxMode, isRoundingOn, (activeTable || tableUsed));

    console.log("aaa summary", summary);

    // Step 4: Calculate for Display Number
    const item4 = calculateDisplayNumbers(items3);

    // Step 5: For items where we assumed are of quantity 1, set them back to null
    const itemsReturn = item4.map(record => {
        const updatedRecord = {...record, dirty: hasErrorFn(tableUsed, record, {}, {})};
        if (updatedRecord.changedQuantity)
            return {...updatedRecord, quantity: null, changedQuantity: false};
        return updatedRecord;
    });

    console.log('aaa1-1 calculateSummary redux 5', {
        item4,
        itemsReturn,
    });

    // Update Store
    yield put({
        type: EditableActions.SET_ITEMS,
        name: tableUsed,
        items: itemsReturn,
        skipFormUpdate: true,
        skipCalculation: true,
    });

    // Set summary
    switch (activeTable || tableUsed) {
        case TableName.bank_item:
            yield put(
                TransactionActions.setBankSummaryData(summary),
            );
            break;
        case TableName.form_item:
        default:
            yield put(
                TransactionActions.setFormSummaryData(summary),
            );
            break;
    }

    // Only for Invoice Applied Link Items
    yield put(
        TransactionActions.setAppliedLinkItems(appliedLinkItems2),
    );
}
